import { Component } from '@angular/core';
import { LoginService } from '../../services/login/login.service';


@Component({
  selector: 'app-cobranzas',
  templateUrl: './cobranzas.component.html',
  styleUrls: ['./cobranzas.component.scss'],
})
export class CobranzasComponent {

  user:any;
  flag:boolean = true;
  constructor(private loginService:LoginService) {
      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
      this.flag = (this.user.id_roles == 45)? false: true;
   }



  clickGuard(){
     this.loginService.clickGuard = true;
  }

}
